import React from 'react';
import { useIntl } from 'react-intl';

import { LazyEmojiComponentLoader } from '@confluence/emoji-title/entry-points/EmojiComponent.tsx';
import { ContentIcon } from '@confluence/icons/entry-points/ContentIcon.ts';
import { SpaceIcon } from '@confluence/icons/entry-points/SpaceIcon.ts';
import { AttachmentIcon } from '@confluence/icons/entry-points/AttachmentIcon.ts';

import { SearchResultType } from '../gql/__types__/AdvancedSearchAGGTypes.ts';
import { i18n } from '../AdvancedSearch-i18n.ts';

export const Icon = ({
	contentType,
	subType = '',
	resultTitle,
	emojiValue,
	iconPath,
}: {
	contentType: SearchResultType | string;
	subType?: string;
	resultTitle?: string;
	emojiValue?: string | undefined;
	iconPath?: string;
}) => {
	const { formatMessage } = useIntl();
	// Handle attachment type - AttachmentIcon is different than ContentIcon
	// in that it will render icon based on attachment extension
	if (contentType === SearchResultType.attachment) {
		return (
			// @ts-expect-error FIXME: legacy ignore after migration; don't add new ones. Error: "label" must be specified for accessibility purposes
			<AttachmentIcon title={resultTitle} size="medium" />
		);
	}

	// Handle space type - SpaceIcon will render space image
	if (contentType === SearchResultType.space) {
		return (
			<SpaceIcon
				size="small"
				src={iconPath}
				label={formatMessage(i18n.spaceIconLabel, {
					spaceName: resultTitle,
				})}
			/>
		);
	}

	// Handle emoji value without subType
	if (emojiValue && !subType) {
		return (
			<LazyEmojiComponentLoader emoji={emojiValue} context="AdvancedSearchResultView" height={24} />
		);
	}

	// Default fallback to ContentIcon
	return <ContentIcon type={contentType} subType={subType} height={24} />;
};
